<div
  *ngIf="isPixAutomatic"
  class="gw-bg-background-elevation-2 gw-border gw-border-border-normal gw-rounded-2xl gw-overflow-hidden gw-p-medium gw-space-y-medium"
>
  <div class="gw-flex gw-flex-wrap gw-items-center gw-gap-small gw-mb-small">
    <span
      class="gw-badge gw-text-sm gw-bg-status-info-pale gw-text-text-primary"
    >
      {{ 'features.subscriptions.view.pixAutomatic.badge' | translate }}
    </span>
    <span class="gw-badge gw-text-sm" [ngClass]="statusBadgeClass">
      {{ statusLabelKey | translate }}
    </span>
    <span
      *ngIf="journeyLabelKey as journeyKey"
      class="gw-text-sm gw-text-text-secondary"
    >
      {{ journeyKey | translate }}
    </span>
  </div>

  <ng-container *ngIf="isPending">
    <p class="gw-m-0 gw-text-text-secondary gw-text-sm">
      {{ 'features.subscriptions.view.pixAutomatic.stillPending' | translate }}
    </p>

    <div *ngIf="qrSrc" class="gw-flex gw-justify-center gw-py-medium">
      <img
        [src]="qrSrc"
        alt="Pix Automático mandate QR"
        class="gw-max-w-[220px] gw-w-full gw-h-auto"
      />
    </div>

    <div class="gw-flex gw-flex-wrap gw-gap-small">
      <gatewee-button
        *ngIf="emv"
        variant="secondary"
        size="s"
        [title]="'features.subscriptions.view.pixAutomatic.copyEmv' | translate"
        (clicked)="copyEmv()"
      ></gatewee-button>
      <gatewee-button
        *ngIf="paymentLinkUrl"
        variant="secondary"
        size="s"
        [title]="
          'features.subscriptions.view.pixAutomatic.openPaymentLink' | translate
        "
        (clicked)="openPaymentLink()"
      ></gatewee-button>
      <gatewee-button
        variant="outline"
        size="s"
        [loading]="refreshing"
        [title]="'features.subscriptions.view.pixAutomatic.refresh' | translate"
        (clicked)="refresh()"
      ></gatewee-button>
    </div>
  </ng-container>

  <ng-container *ngIf="isApproved">
    <p class="gw-m-0 gw-text-text-secondary gw-text-sm">
      {{
        'features.subscriptions.view.pixAutomatic.approvedFutureCharges'
          | translate
      }}
    </p>
  </ng-container>

  <ng-container
    *ngIf="mandateStatus === 'rejected' || mandateStatus === 'canceled'"
  >
    <p class="gw-m-0 gw-text-text-secondary gw-text-sm">
      {{ statusLabelKey | translate }}
    </p>
  </ng-container>

  <div
    *ngIf="showSandboxTools"
    class="gw-mt-medium gw-pt-medium gw-border-t gw-border-border-normal gw-space-y-small"
  >
    <p class="gw-m-0 gw-text-sm gw-font-semibold gw-text-text-primary">
      {{
        'features.subscriptions.view.pixAutomatic.sandboxSection' | translate
      }}
    </p>
    <div class="gw-flex gw-flex-wrap gw-gap-small">
      <gatewee-button
        variant="secondary"
        size="s"
        [loading]="sandboxBusy"
        [title]="
          'features.subscriptions.view.pixAutomatic.sandboxApprove' | translate
        "
        (clicked)="sandboxApprove()"
      ></gatewee-button>
      <gatewee-button
        variant="secondary"
        size="s"
        [loading]="sandboxBusy"
        [title]="
          'features.subscriptions.view.pixAutomatic.sandboxPayCobr' | translate
        "
        (clicked)="sandboxPayCobr()"
      ></gatewee-button>
    </div>
  </div>
</div>
